{
  "version": 1,
  "asset_id": "d2e793a1-b179-4998-8a94-2eaf8e39bd09",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/d2e793a1-b179-4998-8a94-2eaf8e39bd09/sleeve-to-bypass-first-view-es-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/d2e793a1-b179-4998-8a94-2eaf8e39bd09/sleeve-to-bypass-first-view-es-1200.webp",
  "original_filename": "sleeve-to-bypass-first-view-es-1200.webp",
  "size": 61470,
  "content_type": "image/webp",
  "created_at": "2026-10-05T12:34:03Z"
}
